import React from 'react';
import { NavLink } from 'react-router-dom';

const ContactDetails = () => {
    return (
        <section className="contact-details">
            <div className="container c_container">
                <div className="row">
                    <div className="col-12">
                        <div className="contactDetails-header">
                            <h6 className="small-heading" data-aos="fade-up">Contact Details</h6>
                            <h3 className="heading-gradient" data-aos="fade-up">Testigo Healthcare Pvt. Ltd.</h3>
                        </div>
                        <div className="contactDetails-body">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="contactDetails-box">
                                        <h6 className="small-heading" data-aos="fade-up">Address</h6>
                                        <p className="mb-0" data-aos="fade-up">Plot No. 518, Udyog Vihar, Phase 3, Gurugram, Haryana, India - 122016</p>
                                    </div>
                                    <div className="contactDetails-box">
                                        <h6 className="small-heading" data-aos="fade-up">Helpline No.</h6>
                                        <p className="mb-0" data-aos="fade-up"><NavLink to="tel:9998880005" className="text-reset text-decoration-none">999-888-000-5</NavLink></p>
                                        <p className="mb-0" data-aos="fade-up"><NavLink to="tel:18005720005" className="text-reset text-decoration-none">1800-572-0005</NavLink> (Toll free number)</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="contactDetails-box">
                                        <h6 className="small-heading" data-aos="fade-up">Email</h6>
                                        <h5 data-aos="fade-up">Customer Support</h5>
                                        <p className="mb-0" data-aos="fade-up"><NavLink to="mailto:cs@testigo.com" className="text-reset text-decoration-none">cs@testigo.com</NavLink></p>
                                    </div>
                                    <div className="contactDetails-box">
                                        <h5 data-aos="fade-up">Technology</h5>
                                        <p className="mb-0" data-aos="fade-up"><NavLink to="mailto:tech@testigo.com" className="text-reset text-decoration-none">tech@testigo.com</NavLink></p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="contactDetails-box">
                                        <h5 data-aos="fade-up">Marketing</h5>
                                        <p className="mb-0" data-aos="fade-up"><NavLink to="mailto:marketing@testigo.com" className="text-reset text-decoration-none">marketing@testigo.com</NavLink></p>
                                    </div>
                                    <div className="contactDetails-box">
                                        <h5 data-aos="fade-up">Career</h5>
                                        <p className="mb-0" data-aos="fade-up"><NavLink to="mailto:careers@testigo.com" className="text-reset text-decoration-none">careers@testigo.com</NavLink></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactDetails;